import { BrandDepartment } from '../../../../typings/types'

export const modalCopy = {
  subBrand: {
    title: 'Add new sub-brand',
    description: 'Select the department type of your new sub-brand.',
    buttonText: 'Add sub-brand',
  },
  base: {
    title: 'Add new sub-brand',
    description: 'Select the department type of your new sub-brand.',
    buttonText: 'Add sub-brand',
  },
  location: {
    title: 'Add location',
    description: 'Add your new location’s details.',
    buttonText: 'Add location',
  },
  department: {
    title: 'Add department',
    description: 'Add your new department’s details.',
    buttonText: 'Add department',
  },
}

export const subBrandsTabs = [
  {
    title: 'Location',
    icon:
      'https://res.cloudinary.com/ninety-seconds/image/upload/v1635957235/-design-system/icon-dashboard-location.svg',
    onClick: 'location',
  },
  {
    title: 'Department',
    icon:
      'https://res.cloudinary.com/ninety-seconds/image/upload/v1635957235/-design-system/icon-dashboard-department.svg',
    onClick: 'department',
  },
  {
    title: 'Sub-brand',
    icon:
      'https://res.cloudinary.com/ninety-seconds/image/upload/v1670264972/-design-system/icon-edit-sub-brand.svg',
    onClick: 'subBrand',
  },
]

export const departmentTabs = [
  {
    title: 'Sales',
    icon:
      'https://res.cloudinary.com/ninety-seconds/image/upload/v1610607296/-design-system/icon-sales.svg',
    activeIcon:
      'https://res.cloudinary.com/ninety-seconds/image/upload/v1673862474/-design-system/icon-sales_white.svg',
    onClick: BrandDepartment.SALES,
  },
  {
    title: 'Product',
    icon:
      'https://res.cloudinary.com/ninety-seconds/image/upload/v1610607296/-design-system/icon-product.svg',
    activeIcon:
      'https://res.cloudinary.com/ninety-seconds/image/upload/v1673862142/-design-system/icon-product_white.svg',
    onClick: BrandDepartment.PRODUCT,
  },
  {
    title: 'HR & Recruitment',
    icon:
      'https://res.cloudinary.com/ninety-seconds/image/upload/v1610607294/-design-system/icon-hr.svg',
    activeIcon:
      'https://res.cloudinary.com/ninety-seconds/image/upload/v1673862474/-design-system/icon-hr_white.svg',
    onClick: BrandDepartment.HR,
  },
  {
    title: 'Marketing',
    icon:
      'https://res.cloudinary.com/ninety-seconds/image/upload/v1610607294/-design-system/icon-marketing.svg',
    activeIcon:
      'https://res.cloudinary.com/ninety-seconds/image/upload/v1673862474/-design-system/icon-marketing_white.svg',
    onClick: BrandDepartment.MARKETING,
  },
  {
    title: 'Finance',
    icon:
      'https://res.cloudinary.com/ninety-seconds/image/upload/v1610607294/-design-system/icon-finance.svg',
    activeIcon:
      'https://res.cloudinary.com/ninety-seconds/image/upload/v1673862474/-design-system/icon-finance_white.svg',
    onClick: BrandDepartment.FINANCE,
  },
  {
    title: 'Digital',
    icon:
      'https://res.cloudinary.com/ninety-seconds/image/upload/v1610607294/-design-system/icon-digital.svg',
    activeIcon:
      'https://res.cloudinary.com/ninety-seconds/image/upload/v1673862474/-design-system/icon-digital_white.svg',
    onClick: BrandDepartment.DIGITAL,
  },
  {
    title: 'Internal Comms',
    icon:
      'https://res.cloudinary.com/ninety-seconds/image/upload/v1610607294/-design-system/icon-internal-comms.svg',
    activeIcon:
      'https://res.cloudinary.com/ninety-seconds/image/upload/v1673862474/-design-system/icon-internal-comms_white.svg',
    onClick: BrandDepartment.INTERNAL_COMMS,
  },
  {
    title: 'External Comms',
    icon:
      'https://res.cloudinary.com/ninety-seconds/image/upload/v1715256143/-design-system/icon-external-comms.svg',
    activeIcon:
      'https://res.cloudinary.com/ninety-seconds/image/upload/v1715256142/-design-system/icon-external-comms-white.svg',
    onClick: BrandDepartment.EXTERNAL_COMMS,
  },
  {
    title: 'Executive Comms',
    icon:
      'https://res.cloudinary.com/ninety-seconds/image/upload/v1715256405/-design-system/icon-executive-comms.svg',
    activeIcon:
      'https://res.cloudinary.com/ninety-seconds/image/upload/v1715256403/-design-system/icon-executive-comms-white.svg',
    onClick: BrandDepartment.EXECUTIVE_COMMS,
  },
  {
    title: 'Internal Studio',
    icon:
      'https://res.cloudinary.com/ninety-seconds/image/upload/v1715256412/-design-system/icon-studio.svg',
    activeIcon:
      'https://res.cloudinary.com/ninety-seconds/image/upload/v1715256414/-design-system/icon-studio-white.svg',
    onClick: BrandDepartment.INTERNAL_STUDIO,
  },
  {
    title: 'Events',
    icon:
      'https://res.cloudinary.com/ninety-seconds/image/upload/v1715256515/-design-system/icon-events.svg',
    activeIcon:
      'https://res.cloudinary.com/ninety-seconds/image/upload/v1715256513/-design-system/icon-events-white.svg',
    onClick: BrandDepartment.EVENTS,
  },
  // {
  //   title: 'Other',
  //   icon:
  //     'https://res.cloudinary.com/ninety-seconds/image/upload/v1610607294/-design-system/icon-other.svg',
  //   onClick: 'Other',
  // },
]



// WEBPACK FOOTER //
// ./src/components/BrandDashboard/BrandDashboardSubBrands/SubBrands/config.ts